// components/ui/table/TableCell.jsx
export const TableCell = ({ children, className = "" }) => {
  return (
    <td
      className={`p-4 align-middle [&:has([role=checkbox])]:pr-0 ${className}`}
    >
      {children}
    </td>
  );
};
